import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			marginRight: theme.spacing(0.5),
			fontSize: theme.spacing(2.5),
		},
		outer: {
			fill: ({ color }) => color,
		},
		inner: {},
		starFilled: {
			stopColor: ({ color }) => color,
		},
	}),
	{ name: 'StarsRating' },
)

export default useStyles
